export const isAuthenticated = () => {
  const user = localStorage.getItem("user");
  return user;
};

export const isAdminAuthenticated = ()=> {
  const admin = localStorage.getItem("AUTH_TOKEN");
  return admin;
}